import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_2 = { class: "flex justify-end -m-1" }
const _hoisted_3 = { class: "font-medium text-gray-700 break-words" }
const _hoisted_4 = { class: "break-words" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_7 = { class: "flex justify-end" }

import { XCircleIcon } from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'

import FormElement from '@/components/neue/FormElement.vue'
import FormSection from '@/components/neue/FormSection.vue'
import InputField from '@/components/neue/InputField.vue'
import NeueButton from '@/components/neue/NeueButton'
import NeueTablist from '@/components/neue/NeueTablist'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import TheModal from '@/components/TheModal.vue'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapType } from '@/store/mappers'


export default {
  __name: 'DomainsSection',
  setup(__props) {

const domainCols = [{ width: 'minmax(180px, 1fr)' }, { width: 'minmax(220px, 1.5fr)' }, { width: '110px' }]

const canCreateSite = computed(() => privilegeService.canAccessResourceAction('site', null, 'create'))
const canDeleteSite = computed(() => privilegeService.canAccessResourceAction('site', null, 'delete'))

const modalOpen = ref(false)
const name = ref('')

const domains = computed(() => mapType('subdomain'))

api.call('GET', 'domains')

const addDomain = () => {
  if (!canCreateSite.value) return
  api.call('POST', 'domains', { subdomain: { name: name.value } })
  modalOpen.value = false
  name.value = ''
}

const deleteDomain = domain => {
  if (!canDeleteSite.value) return
  api.call('DELETE', 'domains/' + domain.id)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SettingsSection, {
      id: "domains",
      title: "Domains",
      description: "The web addresses your storefront lives at. To use a domain you own, add it here, then go to the company you bought it from and point the domain's CNAME record at the value shown in the CNAME column.",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(NeueTablist), null, {
            head: _withCtx(() => [
              _createVNode(_unref(TablistHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(TablistGrid), {
                    columns: domainCols,
                    header: "",
                    class: "items-center"
                  }, {
                    default: _withCtx(() => [
                      _cache[6] || (_cache[6] = _createElementVNode("div", null, "Name", -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("div", null, "CNAME", -1)),
                      _createElementVNode("div", _hoisted_2, [
                        (canCreateSite.value)
                          ? (_openBlock(), _createBlock(_unref(NeueButton), {
                              key: 0,
                              type: "secondary",
                              onClick: _cache[0] || (_cache[0] = _withModifiers($event => (modalOpen.value = true), ["prevent"]))
                            }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode(" + Domain ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domains.value, (domain) => {
                return (_openBlock(), _createBlock(_unref(TablistRow), {
                  key: domain.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TablistGrid), {
                      columns: domainCols,
                      class: "items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(domain.attributes.name), 1),
                        _createElementVNode("div", _hoisted_4, [
                          (domain.attributes.cname)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(domain.attributes.cname), 1))
                            : (domain.attributes.errors?.message)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(domain.attributes.errors.message), 1))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          (domain.attributes.deletable && canDeleteSite.value)
                            ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                                key: 0,
                                class: "cursor-pointer h-6 w-6 hover:text-black",
                                onClick: $event => (deleteDomain(domain))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(TheModal, {
      "is-open": modalOpen.value,
      "modal-title": "Add a domain",
      onCloseModal: _cache[4] || (_cache[4] = $event => (modalOpen.value = false))
    }, {
      main: _withCtx(() => [
        _createVNode(FormSection, {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers($event => (name.value && addDomain()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(FormElement, null, {
              default: _withCtx(() => [
                _createVNode(InputField, {
                  modelValue: name.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((name).value = $event)),
                  disabled: !canCreateSite.value,
                  name: "Domain name"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[3] || (_cache[3] = $event => (modalOpen.value = false))
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        (canCreateSite.value)
          ? (_openBlock(), _createBlock(_unref(NeueButton), {
              key: 0,
              type: name.value ? 'primary' : 'inactive',
              onClick: addDomain
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("Save", -1)
              ]))]),
              _: 1
            }, 8, ["type"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

}